import { TutorialProps } from '@/services/tutorialService/tutorialTypes';
import { atom } from 'recoil';

export const tutorialState = atom<TutorialProps>({
  key: 'global:tutorialState',
  default: {
    id: '',
    isTutorialActive: false,
    currentStep: 1,
    steps: [],
  },
});
